'use strict';

import { appendQueryParams } from '../utils';

export default (API) => ({
    contactList: {
        searchContactListItems: (establishmentId, contactListId, filters) => {
            let url = `/v3/establishments/${establishmentId}/contacts/${contactListId}/items`;
            url = appendQueryParams(url, filters);
            const request = API.http.get(url);
            return API.handleError(request);
        }
    }
});
